import React from "react";
import * as Ons from "react-onsenui";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import { withDefault } from "../utils/withDefault";
import { Center } from "./Center";
import ScaffoldTitle from "./Scaffold/components/ScaffoldTitle";
import Scaffold from "./Scaffold/Scaffold";

interface Props {
  title?: string;
  onClickGoBack: () => void;
}

const LoadingScaffold = (props: Props) => {
  const title = withDefault(props.title, translate(STRINGS.LOADING));

  return (
    <Scaffold title={<ScaffoldTitle label={title} />} onClickGoBack={props.onClickGoBack}>
      <Center>
        <Ons.ProgressCircular indeterminate={true} />
      </Center>
    </Scaffold>
  );
};

export default React.memo(LoadingScaffold);
